import {formQueryString, getUrlParameter} from '@js/helpers/location';

export function refreshRankingPage(appendCompareOrganizationParams = true, queryParams = null) {
    window.location.search = getRefreshRankingPageParams(appendCompareOrganizationParams, queryParams);
}

export function getRefreshRankingPageParams(appendCompareOrganizationParams = true, queryParams = null) {
    const form = ($('#modal-filters').css('display') === 'block') ? 'modal-filter-form' : 'filters'
    const formElement = $(`form#${form}`)[0];
    const formData = new FormData(formElement);
    let clearedParams = '';
    for (const [key, value] of formData.entries()) {
        if (value && value.trim() !== '') {
            clearedParams += `${key}=${value}&`;
        }
    }
    const queryString = queryParams || clearedParams;
    const params = [queryString];
    if (appendCompareOrganizationParams) {
        const compareOrganizationsInUrl = getUrlParameter('organizations');
        if (compareOrganizationsInUrl && compareOrganizationsInUrl.length) {
            params.push(formQueryString({organizations: compareOrganizationsInUrl}));
        }
    }
    const $modeForm = $('#mode-form');
    if ($modeForm.length) {
        params.push($modeForm.serialize());
    }
    const $sortForm = $('#sort');
    if ($sortForm.length) {
        params.push($sortForm.serialize());
    }
    return params.join('&');
}
